import React from 'react';
import styles from './content.module.less';
import ShownWhen from './shown_when';

export default function ToggleContent({ handleSectionClick, text, number, children, shouldShow }) {
  return (
    <>
      <button className={styles.invisibleButton} type="button" onClick={handleSectionClick}>
        {number}
        <strong>{text}</strong>
        <i className={styles.downArrow}></i>
      </button>
      <br />

      <ShownWhen condition={shouldShow}>{children}</ShownWhen>
    </>
  );
}
